export enum QueryKey {
  Authentication = "Authentication",
  Tenant = "Tenant",
  Role = "Role",
  Person = "Person",
  GoogleCloudStorage = "GoogleCloudStorage",
  Patient = "Patient",
  UtilService = "UtilService",
  Contract = "Contract",
  Billing = "Billing",
  ProviderType = "ProviderType",
  Payment = "Payment",
  Dashboard = "Dashboard",
  Visit = "Visit",
  AttachmentVisit = "AttachmentVisit",
Waiver = "Waiver",
Registration = "Registration",
// KEY ADD
}
